import { Box } from "@mui/material";

const LineChart = () => {
  return (
    <Box sx={{ mt: 3 }}>
      <svg viewBox="0 0 500 190" style={{ width: "100%", display: "block" }}>
        <defs>
          <linearGradient id="warmupGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#7C3AED" stopOpacity="0.25" />
            <stop offset="100%" stopColor="#7C3AED" stopOpacity="0" />
          </linearGradient>
        </defs>

        {/* Y axis label */}
        <text
          x="12"
          y="95"
          textAnchor="middle"
          transform="rotate(-90, 12, 95)"
          fontSize="11"
          fill="#6B7280"
        >
          Emails / week
        </text>

        {/* Grid lines + Y tick labels */}
        {[0, 25, 50, 75, 100].map((v) => {
          const y = 20 + (1 - v / 100) * 130;
          return (
            <g key={v}>
              <line
                x1="55"
                y1={y}
                x2="480"
                y2={y}
                stroke="#E5E7EB"
                strokeWidth="1"
              />
              <text
                x="50"
                y={y + 4}
                textAnchor="end"
                fontSize="11"
                fill="#6B7280"
              >
                {v}
              </text>
            </g>
          );
        })}

        {/* Area fill */}
        <path
          d="M 55,95 L 196,61.5 L 337,44.5 L 480,20 L 480,150 L 55,150 Z"
          fill="url(#warmupGrad)"
        />

        {/* Line */}
        <polyline
          points="55,95 196,61.5 337,44.5 480,20"
          fill="none"
          stroke="#7C3AED"
          strokeWidth="2.5"
          strokeLinejoin="round"
          strokeLinecap="round"
        />

        {/* Dots + value labels */}
        {[
          { x: 55, y: 95, v: 50, label: "Week 1", vx: 72 },
          { x: 196, y: 61.5, v: 65, label: "Week 2", vx: 196 },
          { x: 337, y: 44.5, v: 75, label: "Week 3", vx: 337 },
          { x: 480, y: 20, v: 100, label: "Week 4", vx: 480 },
        ].map((pt) => (
          <g key={pt.label}>
            <circle cx={pt.x} cy={pt.y} r="5" fill="#7C3AED" />
            <circle cx={pt.x} cy={pt.y} r="3" fill="white" />
            <text
              x={pt.vx}
              y={pt.y - 10}
              textAnchor="middle"
              fontSize="11"
              fontWeight="600"
              fill="#7C3AED"
            >
              {pt.v}
            </text>
            <text
              x={pt.x}
              y="175"
              textAnchor="middle"
              fontSize="11"
              fill="#6B7280"
            >
              {pt.label}
            </text>
          </g>
        ))}

        {/* X axis line */}
        <line
          x1="55"
          y1="150"
          x2="480"
          y2="150"
          stroke="#D1D5DB"
          strokeWidth="1"
        />
      </svg>
    </Box>
  );
};

export default LineChart;
